import { inject, Injectable } from '@angular/core';
import { Document, Dispatch } from './interfaces';
import { DocumentDialog } from './components/document-dialog/document-dialog';
import { MatDialog } from '@angular/material/dialog';
import { ExceptionDialog } from './components/exception-dialog/exception-dialog';
import { DispatchPaymentStatus } from './constants';
import { DocumentApiService } from './api/document-api.service';
import { DispatchApiService } from './api/dispatch-api.service';
import { ObjectStorageService } from './storage/object-storage.service';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  dialog = inject(MatDialog);

  constructor(
    private documentApi: DocumentApiService,
    private dispatchApi: DispatchApiService,
    private objectStorage: ObjectStorageService,
  ) {}

  openDialog(document: Document) {
    const dialogRef = this.dialog.open(DocumentDialog, {
      data: {
        document: document,
        isDocument: true,
      },
      minWidth: '85%',
    });
    dialogRef.afterClosed().subscribe((result: Boolean) => {
      if (result) {
        this.getDownloadUrl(document.url);
        this.documentApi.markRead(document.id!).subscribe({
          next: () => {
            document.status = 'read';
          },
          error: (error) => {
            console.error(error);
          },
        });
      }
    });
  }

  addAdditionalInfo(dispatch: Dispatch, status: DispatchPaymentStatus, onUpdated?: () => void): void {
    const dialogRef = this.dialog.open(ExceptionDialog, {
      data: { status },
      minWidth: '50%',
    });
    dialogRef.afterClosed().subscribe((result: string) => {
      if (result) {
        if (status === DispatchPaymentStatus.EXCEPTION) {
          this.dispatchApi.addException(dispatch.id, result).subscribe({
            next: () => {
              dispatch.paymentStatus = DispatchPaymentStatus.EXCEPTION;
              onUpdated?.();
            },
            error: (error) => {
              console.error(error);
            },
          });
        } else if (status === DispatchPaymentStatus.PAID) {
          this.dispatchApi.markPaid(dispatch.id, result).subscribe({
            next: () => {
              dispatch.paymentStatus = DispatchPaymentStatus.PAID;
              onUpdated?.();
            },
            error: (error) => {
              console.error(error);
            },
          });
        }
      }
    });
  }

  getDownloadUrl(fileKey: string) {
    this.objectStorage.openDownload(fileKey);
  }

  timeAgo(date: string | Date): string {
    const now = new Date().getTime();
    const past = new Date(date).getTime();
    const diff = now - past;
    const units = [
      { label: 'year', ms: 1000 * 60 * 60 * 24 * 365 },
      { label: 'month', ms: 1000 * 60 * 60 * 24 * 30 },
      { label: 'day', ms: 1000 * 60 * 60 * 24 },
      { label: 'hour', ms: 1000 * 60 * 60 },
      { label: 'minute', ms: 1000 * 60 },
      { label: 'second', ms: 1000 },
    ];
    for (const unit of units) {
      const value = Math.floor(diff / unit.ms);
      if (value >= 1) {
        return `${value} ${unit.label}${value > 1 ? 's' : ''} ago`;
      }
    }
    return 'just now';
  }
}
